import Link from 'next/link';
import { useRouter } from 'next/router';

import { Text, Typography } from '@/sharedComponents/v1/Components/Typography';
import Logo from '@/sharedComponents/Logo';
import LoginSignupForm from '@/components/LoginSignupForm';

import { LOGO_URL, PRIVACY_POLICY_LINK, TERMS_OF_SERVICE_LINK } from '@/constants';
import { styFadeInFromBottom } from '@/styles/AnimationStyle';
import { styLoginContainer } from './style';

function SignupSection({ bypass }: {bypass: boolean}) {
  const router = useRouter();

  return (
    <div css={[styLoginContainer, styFadeInFromBottom]}>
      <Logo logoURL={LOGO_URL} link="/" width={156} height={40} />
      <Typography body="display-sm-semibold" type="main" margin="28px 0 6px 0">
        Sign up and build your site
      </Typography>
      <Typography margin="0 0 42px 0">
        By signing up, you agree to our
        <a href={TERMS_OF_SERVICE_LINK} target="_blank" rel="noreferrer">
          <Text
            body="text-sm-semibold"
            type="link"
          >
            {' '}
            Terms of Service
            {' '}
          </Text>
        </a>
        and
        <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noreferrer">
          <Text
            body="text-sm-semibold"
            type="link"
          >
            {' '}
            Privacy Policy
            {' '}
          </Text>
        </a>
      </Typography>
      <LoginSignupForm login={false} redirect />
      <Typography margin="12px 0">
        Already have an account?
        {' '}
        <Link
          href={{
            pathname: '/login',
            query: router.query,
          }}
        >
          Log in
        </Link>
      </Typography>
    </div>
  );
}

export default SignupSection;
